import constants from '../constants'

export const fonts = {
  default: {
    title: "'Playfair Display', serif",
    subtitle: "'Roboto', sans-serif",
    primary: "'Roboto', sans-serif",
    secondary: "'Arial', sans-serif",
  },

  'anaya-care': {
    title: "'Sora', sans-serif",
    subtitle: "'Inter', sans-serif",
    primary: "'Inter', sans-serif",
    secondary: "'Inter', sans-serif",
  },
  [constants.CARE_PROGRAM_TYPE.GLP]: {
    title: 'Montserrat',
    subtitle: 'Montserrat',
    primary: 'Montserrat',
    secondary: 'Montserrat',
  },
}
